<div class="center-xy">
    @if (parameters.redirecting || !subtitles.downloaded) {
        <div class="statistics__loading">
            <div class="statistics__loading__img">
                <loader></loader>
            </div>
        </div>
    }

    @if (subtitles.downloaded) {
        <div class="login-box bg-light" data-testid="login-box">
            <img class="login-box__logo"
                 [ngClass]="parameters.loginBoxLogoClass"
                 [src]="'/assets/img/' + logoSrc" alt=""/>

            @if (externalLogin === 'my-client') {
                <div class="font-11 color-basic login_header__agreement-google">
                    {{ subtitle(10766) }}
                </div>
            }

            <form>
                <label for="username">{{ subtitle(1132) }} / {{ subtitle(1110) }}</label>
                <input type="text"
                       class="login-box__text-input border-input color-basic font-16 font-regular"
                       name="username"
                       [attr.aria-label]="subtitle(1132) + ' / ' + subtitle(1110)"
                       autocapitalize="none"
                       [(ngModel)]="authentication.username"
                       [placeholder]="'user@email.com'"
                       (keydown.enter)="authentication.login()">

                <label for="password">{{ subtitle(1101) }}</label>
                <div class="login-box__password-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'"
                           class="login-box__text-input border-input color-basic font-16 font-regular"
                           name="password"
                           [attr.aria-label]="subtitle(1101)"
                           [(ngModel)]="authentication.password"
                           [placeholder]="showPassword ? subtitle(1101) : '********'"
                           (keydown.enter)="authentication.login()">

                    <img [ngSrc]="showPassword
                                ? '/assets/img/icons/eye.svg'
                                : '/assets/img/icons/eye_slash.svg'"
                         class="login-box__eye-icon"
                         (click)="togglePasswordVisibility()"
                         priority="true"
                         width="24" height="24" alt=""/>
                </div>
            </form>

            <div>
                <button type="button"
                        class="login-box__button bg-gradient color-light font-bold font-20 cursor-pointer"
                        (click)="authentication.login()">
                    {{ subtitle(1092) }}
                </button>
                <div class="remember-pass-wrapper">
                    <div class="remember-pass cursor-pointer"
                         (click)="authentication.rememberMe = !authentication.rememberMe">

                        @if (!externalLogin) {
                            <div class="remember-pass__icon-wrapper bg-input border-input">
                                @if (authentication.rememberMe) {
                                    <img class="remember-pass__icon"
                                         [src]="'/assets/img/icons/checkbox_checked.svg'"
                                         alt=""/>
                                }
                            </div>
                            <div class="remember-pass__text font-13 color-basic">
                                {{ subtitle(1854) }}
                            </div>
                        }
                    </div>
                    <div class="forgotten-pass cursor-pointer">
                        <div class="forgotten-pass__text font-13 color-basic"
                             (click)="goForgotPassword()">
                            {{ subtitle(1853) }}
                        </div>
                    </div>
                </div>
            </div>

            @if (showDemoAccountButton() && !externalLogin) {
                <button type="button"
                        class="login-box__demo-button border-primary color-primary font-16 font-bold cursor-pointer"
                        (click)="loginDemoAccount()">
                    {{  subtitle(1913) }}
                </button>
            }
        </div>
    }
</div>
